const settings = {
  companyName: 'Getro',
  membersPerPage: 20,
};

export default settings;
